import { MaskedTextField, Stack } from "@fluentui/react";

import { FilterComponentProps } from "./interfaces";

import { isObjectEmpty } from "@/utils/IsObjectEmpty";

export function MaskedText({
  filterConfigs,
  selectedTerms,
  setVisibleTerms,
  setSelectedTerms,
  mask
}: FilterComponentProps): JSX.Element {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value;

    setVisibleTerms(prevState => ({
      ...prevState,
      [filterConfigs.filterQuery as string]: rawValue
    }));

    const conditionalSearch = filterConfigs.customConditional
      ? filterConfigs.customConditional(rawValue)
      : filterConfigs.valueFormatter(rawValue) !== "";

    if (conditionalSearch) {
      setSelectedTerms(prevState => ({
        ...prevState,
        [filterConfigs.filterQuery as string]:
          filterConfigs.valueFormatter(rawValue)
      }));
    } else if (
      !isObjectEmpty(selectedTerms) &&
      selectedTerms[filterConfigs.filterQuery as string]
    ) {
      setSelectedTerms(prevState => {
        const updatedState = { ...prevState };
        delete updatedState[filterConfigs.filterQuery as string];

        return updatedState;
      });
    }
  };

  return (
    <Stack>
      <label style={{ fontWeight: 600, padding: "5px 0px" }}>
        {filterConfigs.label}
      </label>
      <MaskedTextField
        type={filterConfigs.inputType ?? filterConfigs.type}
        disabled={Boolean(filterConfigs.disabled)}
        placeholder={filterConfigs.placeholder}
        onChange={handleInputChange}
        style={{
          minWidth: filterConfigs?.minWidth
        }}
        mask={mask}
      />
    </Stack>
  );
}
